export default __webpack_public_path__ + "warningIcon.5db832edfbd4a9e02afe1a9cf7dea16f.svg";